export class TvAccountGeneralData {
    public balance: number = 0;
    public projectedBalance: number = 0;
    public availableFunds: number = 0;
    public blockedBalance: number = 0;
    public unsettledCash: number = 0;
}
